'use strict';

var _ = require('lodash');
var FlightAnalysisPanelController = function FlightAnalysisPanelController($scope, $rootScope, $timeout, demandPostingService, featureToggleService, dataRetrieverService, dataRetrieverConstants, analysisMetricService, dataService, BrushSelectionFilter, currentStateCriteriaService, flightAnalysisService, scenarioService, visibilityManager, userPreferencesService, applicableSeasonsLoadingService, liveDataService, reoptimizationService, reoptPreviewDataUtilsService, referenceValueToggleService, marketGridsDataService, flightModeService, pooledSeasonalityReviewConstants) {
  $scope.isDAOnlyMode = flightModeService.isDAOnlyMode();
  $scope.screen = dataRetrieverConstants.FLIGHT_SCREEN;
  $scope.defaultMode = $scope.isDAOnlyMode ? dataRetrieverConstants.CABIN_DA_MODE : dataRetrieverConstants.CABIN_MODE;
  $scope.postDepartureModeName = dataRetrieverConstants.CABIN_POST_DEPARTURE_MODE;
  $scope.visibilityManager = visibilityManager;
  $scope.visibilityManager.resetVisibility();
  $scope.postDepartureMode = currentStateCriteriaService.isPostDeparture();
  $scope.charts = require('../config/ThematicChartsConfig.json');
  $scope.scenarioName = scenarioService.getSelectedScenarioName();
  $scope.isPooledSeasonalityEnabled = false;
  var availableMetrics = [{
    id: 'booking',
    label: 'Bookings',
    chartType: 'profile-chart'
  }, {
    id: 'loadFactor',
    label: 'Load Factor',
    chartType: 'profile-chart'
  }];
  if (!$scope.isDAOnlyMode) {
    availableMetrics.push({
      id: 'revenue',
      label: 'Revenue',
      chartType: 'profile-chart'
    });
    if (featureToggleService.isEnabled('COMPFARE_AVAILABILITY')) {
      availableMetrics.push({
        id: 'competitorFaresProfile',
        label: 'Comp Fares',
        extendedLabel: 'Competitor Fares'
      });
    }
  } else {
    $scope.charts = _.filter($scope.charts, function (chart) {
      return chart.type !== 'thematic-flight-chart-season';
    });
  }
  var defaultProfileChart = availableMetrics[0];
  $scope.screenState = {
    flightAnalysisMode: {
      visible: true
    },
    flightManagementMode: {
      visible: false
    },
    flightAnalysisPanel: {
      visible: true
    },
    filters: {},
    demandTransparencyPanel: {
      visible: false,
      contextData: {}
    },
    demandPostingPanel: {
      visible: false,
      contextData: {}
    },
    profileChartPanel: {
      visible: false,
      contextData: {},
      metricList: availableMetrics
    },
    dimension: featureToggleService.isEnabled('MAPPED_MODE') ? 'regular' : 'mapped',
    cogOptionsSet: _.clone(require('../config/cogOptionsSet.json')),
    dataRepresentation: userPreferencesService.getUserSettingComponent('defaultDataRepresentation') || 'absolute',
    metric: undefined,
    selectedReference: undefined,
    referenceValueModes: undefined,
    referenceValueModesAvailable: false,
    searchReady: false
  };
  $scope.reoptPreviewData = {
    ndReopt: null,
    flightDetails: {}
  };
  $scope.profileChart = {
    type: 'flight-profile-chart',
    "class": 'rmProfileChart',
    visible: true,
    metrics: {
      metricList: availableMetrics,
      selectedMetric: availableMetrics[0]
    }
  };
  $scope.$on('cog:flightAnalysisToolbar', function (event, dimension) {
    $scope.screenState.dimension = dimension.val[0];
  });
  $scope.$on('demand-transparency:swap', function ($event, isShown, contextData) {
    var data = contextData && contextData.demandData ? contextData.demandData : contextData;
    if (featureToggleService.isEnabled('POOLED_SEASONALITY') && isShown) {
      $scope.isPooledSeasonalityEnabled = true;
      $scope.screenName = pooledSeasonalityReviewConstants.SCREEN_ID_MARKET_ANALYSIS;
      $scope.demandTransparencyAttributes = contextData.demandTransparencyAttributes;
      $scope.displayedCalendar = contextData.displayedCalendar;
    }
    $scope.screenState = _.assign($scope.screenState, {
      demandTransparencyPanel: {
        contextData: data,
        visible: isShown
      },
      flightAnalysisPanel: {
        visible: !isShown
      }
    });
  });
  $scope.$on('demand-posting:swap', function ($event, isShown, contextData) {
    $scope.screenState = _.assign($scope.screenState, {
      demandPostingPanel: {
        contextData: contextData,
        visible: isShown
      },
      flightAnalysisPanel: {
        visible: !isShown
      }
    });
    $timeout(function () {
      demandPostingService.scrollDown('.demand-management-panel', isShown);
    }, 0);
  });
  $scope.$on('profile-chart-panel:swap', function ($event, isShown, newContextData) {
    var existingContext = $scope.screenState.profileChartPanel.contextData;
    var selectedReferenceContext = {
      selectedReference: $scope.screenState.selectedReference
    };
    $scope.screenState.profileChartPanel = _.assign($scope.screenState.profileChartPanel, {
      contextData: _.assign(existingContext, newContextData, selectedReferenceContext),
      visible: isShown
    });
    $scope.screenState.flightAnalysisPanel = _.assign($scope.screenState.flightAnalysisPanel, {
      visible: !isShown
    });
  });
  var analysisMetric = analysisMetricService.getAnalysisMetric($scope.screen);
  var cabinDataRetriever = dataRetrieverService.getDataRetriever($scope.screen, $scope.defaultMode);
  cabinDataRetriever.updateMetricValues(analysisMetric.getDefault());
  var brushFilters = {};
  var defaultBrushFilters = {};
  function setDtdCriteria() {
    var searchCriteria = currentStateCriteriaService.getSearchCriteria();
    var dtdCriteria = _.chain(searchCriteria.rules).filter(function (item) {
      return item.shortCriterionName === 'DTD';
    }).map(function (item) {
      return _.pick(item, ['operator', 'leftOperand', 'rightOperand']);
    }).value();
    cabinDataRetriever.updateAdditionalParameters({
      dtdCriteria: dtdCriteria
    });
  }
  function setDataRetrieverScenarios() {
    var scenarios = [];
    if (!currentStateCriteriaService.isPostDeparture()) {
      scenarios = $scope.scenarioName ? [scenarioService.PUBLISHED, $scope.scenarioName] : [scenarioService.PUBLISHED];
    }
    dataRetrieverService.setScenarios(scenarios, dataRetrieverConstants.FLIGHT_SCREEN);
    dataRetrieverService.setScenarios(scenarios, dataRetrieverConstants.MARKET_SCREEN);
    $scope.screenState.searchReady = true;
  }
  $scope.getCurrentMode = function () {
    return $scope.postDepartureMode ? $scope.postDepartureModeName : $scope.defaultMode;
  };
  $scope.onSearchChangeEvent = function () {
    $scope.visibilityManager.resetVisibility();
    $scope.resetProfileChartSelectedMetric();
    brushFilters = {};
    $scope.screenState.filters = {};
    setDtdCriteria();
    dataService.clearCache();
    dataRetrieverService.resetBrushFilters($scope.screen);
    setDataRetrieverScenarios();
    $scope.initReferenceValueModes();
    var fromWorkflow = $scope.postDepartureMode ? 'flightAnalysisPostDeparture' : 'flightAnalysis';
    $scope.kpiRibbonCollapsed = userPreferencesService.getUserSettingComponent('collapseKpis', fromWorkflow);
    $scope.$broadcast('flight-analysis:kpi-ribbon-collapsed', $scope.kpiRibbonCollapsed);
  };
  $scope.$on('screen:onBeforeSearchChangeEvent', function () {
    dataService.clearCache();
    dataRetrieverService.resetBrushFilters($scope.screen);
    $scope.postDepartureMode = currentStateCriteriaService.isPostDeparture();
    $scope.demandManagementData = undefined;
  });
  $scope.$on('search-criteria:searchChangeEvent', $scope.onSearchChangeEvent);
  $scope.$on('scenarios:changed', function (event, scenario, skipSearch) {
    liveDataService.unsubscribeByMode('flight');
    $scope.scenarioName = scenarioService.getSelectedScenarioName();
    dataService.clearCache();
    $scope.postDepartureMode = currentStateCriteriaService.isPostDeparture();
    setDataRetrieverScenarios();
    if (!skipSearch) {
      $scope.$broadcast($scope.screen + ':scenariosChanged');
    }
  });
  function areAllBarsSelected(filter) {
    var selectionCount = 0;
    if (filter.filterType === 'dateRange') {
      _.forEach(filter.filterArguments[0], function (filterAgrument) {
        if (filterAgrument.to) {
          selectionCount += filterAgrument.to.diff(filterAgrument.from, 'days') + 1;
        }
      });
    } else {
      _.forEach(filter.filterArguments, function (filterAgrument) {
        selectionCount += filterAgrument.length;
      });
    }
    return selectionCount === filter.barCount;
  }
  $scope.onBrushFilterApplied = function (event, selectedBrush, silentSelectionClear) {
    if (event.stopPropagation) {
      event.stopPropagation();
      if (selectedBrush.filterType === 'dateRange') {
        var filterSize = _.size(brushFilters);
        if (filterSize > 1 && brushFilters.dateRange || filterSize > 0 && !brushFilters.dateRange) {
          //if date range chart brush reset not only itself but some another brush, dateRangeChart
          // should be re-rendered after other charts send its reset filters
          selectedBrush.reset = true;
        }
        brushFilters = {};
      } else if (selectedBrush.filtertype !== 'profileChart' && brushFilters.profileChart) {
        delete brushFilters.profileChart;
      } else if (selectedBrush.filterType === 'legs') {
        applicableSeasonsLoadingService.loadApplicableSeasons(selectedBrush.filterArguments[0], dataRetrieverConstants.FLIGHT_SCREEN);
        delete brushFilters.flightLevel;
      }
      if (!selectedBrush.isEmpty()) {
        brushFilters[selectedBrush.filterType] = selectedBrush;
      } else {
        delete brushFilters[selectedBrush.filterType];
      }
      $scope.visibilityManager.setBrushFilters(brushFilters);
      dataRetrieverService.setBrushFilters(brushFilters, $scope.screen);
      if (!silentSelectionClear) {
        $scope.$broadcast('brush-filter:filterApplied', selectedBrush);
      } else if ($scope.visibilityManager.isFlightLevelChartVisible()) {
        $scope.$broadcast('flight-level-chart:reload', brushFilters.legs);
      }
      $scope.screenState.filters[selectedBrush.filterType] = _.cloneDeep(selectedBrush.filterArguments);
      $scope.screenState.filters[selectedBrush.filterType].areAllBarsSelected = areAllBarsSelected(selectedBrush);
    }
  };
  $scope.$on('brush-filter:filterApplied', $scope.onBrushFilterApplied);
  $scope.onDefaultBrushFilterApplied = function (event, brushFilter) {
    if (event.stopPropagation) {
      if (brushFilter.filterType === 'dateRange') {
        defaultBrushFilters = {};
      }
      if (brushFilter.clear) {
        delete defaultBrushFilters[brushFilter.filterType];
      } else {
        defaultBrushFilters[brushFilter.filterType] = brushFilter;
      }
      $scope.visibilityManager.setDefaultBrushFilters(defaultBrushFilters);
      $scope.$broadcast('brush-filter:defaultBrush', brushFilter);
    }
  };
  $scope.$on('brush-filter:defaultBrush', $scope.onDefaultBrushFilterApplied);
  $scope.$on('class-mix-graph:close', function () {
    $scope.$emit('brush-filter:filterApplied', new BrushSelectionFilter('profileChart', []));
    $rootScope.$broadcast('class-mix-graph:close-broadcast');
  });
  function getSelectedLegCabinIds(selectedRows) {
    var rows = _.isEmpty(selectedRows["class"]) ? selectedRows.cabin : selectedRows["class"];
    return _.map(rows, 'legCabinId');
  }
  $scope.$on('flight-analysis:flight-grids-selection-changed', function (event, selectedRows) {
    if ($scope.postDepartureMode || $scope.screenState.demandPostingPanel.visible) {
      return;
    }
    $scope.screenState.filters.selectedLegCabinIds = getSelectedLegCabinIds(selectedRows);
    if (!$scope.isDAOnlyMode && reoptPreviewDataUtilsService.shouldUndoMdReopt($scope.reoptPreviewData, selectedRows.cabin)) {
      reoptimizationService.undoMdReoptAndReload($scope.reoptPreviewData);
      return;
    }
    if (!$scope.isDAOnlyMode) {
      $scope.demandManagementData = marketGridsDataService.prepareDemandManagementData(selectedRows);
    }
  });
  $scope.$watch('profileChart.metrics.selectedMetric', function (selectedChart) {
    $scope.visibilityManager.setCompFareChartVisibility(selectedChart.id === 'competitorFaresProfile');
  });
  $scope.initReferenceValueModes = function (forcedSelection) {
    if (_.isNil($scope.screenState.referenceValueModes)) {
      var selection = $scope.postDepartureMode ? 'lastYear' : forcedSelection;
      var referenceValueProperties = referenceValueToggleService.getInitialReferenceValues(selection);
      $scope.screenState = _.extend($scope.screenState, referenceValueProperties);
    }
  };
  $scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    var transitionScreenState = _.get(toParams, ['transitionData', 'screenState']);
    if (transitionScreenState) {
      $scope.screenState.metric = transitionScreenState.selectedMetric;
      $scope.screenState.dimension = transitionScreenState.dataDimension;
      $scope.screenState.dataRepresentation = transitionScreenState.dataRepresentation;
      $scope.initReferenceValueModes(transitionScreenState.selectedReference);
    }
  });
  $scope.$on('cog:date-range-chart', function (event, value) {
    $scope.screenState.dataRepresentation = value.val[0];
  });
  $scope.resetProfileChartSelectedMetric = function () {
    $scope.profileChart.metrics.selectedMetric = defaultProfileChart;
  };
  function clearRestoredBrushes() {
    delete defaultBrushFilters.flightLevel;
  }
  function clearAdditionalFiltersParamteres() {
    delete $scope.screenState.filters.flightLevel;
    delete $scope.screenState.filters.profileChart;
    delete $scope.screenState.filters.selectedLegCabinIds;
  }
  $scope.resetCharts = function () {
    clearRestoredBrushes();
    clearAdditionalFiltersParamteres();
    $scope.$broadcast('brush-filter:resetCharts');
  };
  flightAnalysisService.setDataRetrieversSorting();
};
FlightAnalysisPanelController.$inject = ['$scope', '$rootScope', '$timeout', 'DemandPostingService', 'FeatureToggleService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'AnalysisMetricService', 'DataService', 'BrushSelectionFilterFactory', 'CurrentStateCriteriaService', 'FlightAnalysisService', 'ScenarioService', 'FlightComponentVisibilityManagerService', 'UserPreferencesService', 'ApplicableSeasonsLoadingService', 'LiveDataService', 'ReoptimizationService', 'ReoptPreviewDataUtilsService', 'ReferenceValueToggleService', 'MarketGridsDataService', 'FlightModeService', 'PooledSeasonalityReviewConstants'];
module.exports = FlightAnalysisPanelController;